import React from 'react';

const TopBtns = ({ children, onClick, ClassBtn = "BtnsTop"}) => {
  return (
    <div onClick={onClick} className={ClassBtn}>
      {children}
    </div>
  );
};

export default TopBtns;